
    import './styles.scoped.css';
    export default {
  "button-dropdown": "awsui_button-dropdown_sne0l_ufft6_12",
  "full-width": "awsui_full-width_sne0l_ufft6_15",
  "items-list-container": "awsui_items-list-container_sne0l_ufft6_20",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_sne0l_ufft6_1",
  "rotate": "awsui_rotate_sne0l_ufft6_39",
  "rotate-open": "awsui_rotate-open_sne0l_ufft6_53",
  "header": "awsui_header_sne0l_ufft6_57",
  "title": "awsui_title_sne0l_ufft6_68",
  "description": "awsui_description_sne0l_ufft6_69",
  "trigger-button": "awsui_trigger-button_sne0l_ufft6_73",
  "loading": "awsui_loading_sne0l_ufft6_81",
  "split-trigger-wrapper": "awsui_split-trigger-wrapper_sne0l_ufft6_85",
  "trigger-item": "awsui_trigger-item_sne0l_ufft6_88",
  "has-no-text": "awsui_has-no-text_sne0l_ufft6_97",
  "visual-refresh": "awsui_visual-refresh_sne0l_ufft6_100",
  "has-trigger-text": "awsui_has-trigger-text_sne0l_ufft6_114",
  "variant-normal": "awsui_variant-normal_sne0l_ufft6_123",
  "split-trigger": "awsui_split-trigger_sne0l_ufft6_85",
  "dropdown-trigger": "awsui_dropdown-trigger_sne0l_ufft6_134",
  "main-action-full-width": "awsui_main-action-full-width_sne0l_ufft6_138",
  "main-action-trigger-full-width": "awsui_main-action-trigger-full-width_sne0l_ufft6_142",
  "filter": "awsui_filter_sne0l_ufft6_146",
  "test-utils-button-trigger": "awsui_test-utils-button-trigger_sne0l_ufft6_152"
};
  